import React from 'react';
import CommentChart from './questionChartsCommentChart';
import MultiLineChart from './questionChartsMultiLineChart';
import PieChart from './questionChartsPieChart';
import StackRankingChart from './questionChartsStackRankingChart';
import ConstantSumChart from './questionChartsConstantSumChart';

const QuestionChart = ({ questionData, questionNumber, isSummary }) => {
  switch(questionData.type.toUpperCase()){
    case "COMMENT":
      return (
        <div className="multiline">
          <CommentChart data={questionData} number={questionNumber} isSummary={isSummary} />
        </div>
      );
    case "TEXT":
      return (
        <div>
          <CommentChart data={questionData} number={questionNumber} isSummary={isSummary}/>
        </div>
      );
    case "MULTILINETEXT":
      return (
        <div>
          <MultiLineChart questionData={questionData.options} number={questionNumber} isSummary={isSummary} />
        </div>
      );
    case "CHECKBOX":
    case "RADIOGROUP":
    case "DROPDOWN":
    case "STARRATING":
    case "RATING":
    return (
        <div>
          <PieChart questionData={questionData} number={questionNumber} isSummary={isSummary}/>
        </div>
      );
    case "STACKRANK":
      return (
        <div>
          <StackRankingChart responses={questionData.options} number={questionNumber} responseCount={questionData.responseCount} isSummary={isSummary}/>
        </div>
      );
    case "CONSTANTSUM":
      return (
        <div>
          <ConstantSumChart responses={questionData.options} number={questionNumber} responseCount={questionData.responseCount} isSummary={isSummary}/>
        </div>
      );
    default:
      return(
        <div>
          <mark>This should be a {questionData.type.toUpperCase()} chart.</mark>
        </div>
      );
  }
}
  




export default QuestionChart;